import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserResponse } from './../../constants/types'

interface UsersState {
  userInfo: UserResponse | null
}

const initialState: UsersState = {
  userInfo: null,
}

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUserInfo(state, action: PayloadAction<UserResponse | null>) {
      state.userInfo = action.payload
    },
  },
})

export const usersActions = usersSlice.actions
export const usersReducer = usersSlice.reducer
